//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


	import {getProjBudgetData,getProjBudgetPersonData,getProjStagePlanLvlList} from '@/api/pm/budget';
	import {dateFormat} from '@/utils/common';

	export default {
		name:'budgetDetail',
		data(){
	      return {
	      	gobackName: this.$route.params.gobackName,
	      	ids: this.$route.params.ids,
	        mainId: this.$route.params.mainId,
	      	// 项目起止日期
	      	projStartDate: this.$route.params.projStartDate,
	      	projEndDate: this.$route.params.projEndDate,
	      	// 预算类型 1：全面预算种类 2：人天预算种类
	      	budgetType: this.$route.params.budgetType,
	      	// 主表数据
	      	budgetData:{},
		    // 阶段数据
		    stageData: [],
	      	// 内部人员数据
	      	inPersonData:[],
	      	// 外部人员数据
	      	outPersonData:[],
	      	// 直接成本数据
	      	costData:[],
	      	// 项目预算数据（月度预算）
	      	budgetCostData:[],
	      	open:false,
	      	// 是否固定 drawer
	      	docked:false,
	      	// drawer 位置
	      	position:'right',
	      	// 激活的项
	      	activeItem:1,
	      	// 项目所跨月份数
	      	sumMonth:0,
	      	//--- 各成本 ---
	      	totalCost:0,
	      	inPersonCost:0,
	      	outPersonCost:0,
	      	otherCost:0,
	      	// 合同总金额
	      	sumContAmt:0,
	      	// 毛利率
	      	gm:'',
	      	openFullscreen:false,
	      	// 人员计划详细数据
	      	personPlanInfo:{},
	      	// 人员计划类型 1：内部人员 2：外部人员
	      	personPlanType:'1',
	      	// 人员月度详情
	      	personMonthData:[],
	      	// 年份数组
	      	yearArr:[],
	      	// 月份数组
	      	monthArr:[],
	      	// 阶段嵌套列表是否显示
	      	itemOpen:'',
	      	itemTwoOpen:'',
	      	// 内部、外部人员数量
	      	inPersonCount:0,
	      	outPersonCount:0,
	      	// 人天预算种类 人员详细
	      	openServiceFullscreen:false
	      }
		},
		created(){
			// 加载数据
			this.loadData();
		},
		computed:{

		},
		mounted: function(){
		},
		methods:{
			//时间格式化
			dateFormatter(date) {
				return dateFormat(date);
			},
			// 返回
			goback(){
				// 返回工作台
				//this.$router.push({ name:'项目预算列表'});
        		//this.$router.go(-1);
        		this.$router.push({
					name: '项目预算列表',
					params: {
						mainId: this.mainId,
						projStartDate: this.projStartDate,
						projEndDate: this.projEndDate,
						budgetType: this.budgetType,
						ids: this.ids,
						gobackName : this.gobackName
					}
				});
			},
		    // 加载数据
		    loadData(){
      			var condition = {'budgetId':this.mainId,'projStartDate':this.projStartDate,'projEndDate':this.projEndDate};

      			// 全面预算种类
      			if(this.budgetType === '1'){
			        getProjBudgetData(condition).then(response => {
			        	// 数据赋值

			          // 预算主表数据
			          this.budgetData = response.projBudgetData;
			          // 内部人员计划数据
			          this.inPersonData = response.inPersonPlanData;
			          // 外部人员计划数据
			          this.outPersonData = response.outPersonPlanData;
			          // 直接成本数据
			          this.costData = response.projCostPlanData;

			          // 合同总金额
			          this.sumContAmt = this.budgetData.sumContAmt;
			          // 各成本
			          this.totalCost = this.budgetData.sumCost;
			          this.inPersonCost = this.budgetData.intLaborCost;
			          this.outPersonCost = this.budgetData.extLaborCost;
			          this.otherCost = this.budgetData.otherCost;

			          // 计算月份数
			          this.calcSumMonth();
			          // 计算项目预算
			          this.calcProjBudgetData();
			        });

			        // 项目阶段层级数据
			        var query = {'budgetId':this.mainId};
			        getProjStagePlanLvlList(query).then(response => {
			        	// 数据赋值
			        	this.stageData = response;
			        });
      			}else{
      			  // 人天预算种类
			      condition = {'budgetId':this.mainId};
			      getProjBudgetPersonData(condition).then(response => {
			        if(response){
			          // 预算主表数据
			          this.budgetData = response.projBudgetData;
			          this.inPersonData = response.inPersonPlanData;
			          this.outPersonData = response.outPersonPlanData;
			          // 人员数量
		      		  this.inPersonCount = this.inPersonData.length;
		      		  this.outPersonCount = this.outPersonData.length;
			        }
			      });
			  }
		    },
		    // 点击事件
		    drawerItemClick(v){
		    	this.open = false;
		    	//this.activeItem = v;
		    	var a = 'state' + v;
		    	 $("html,body").animate({
		        		scrollTop: $('.'+a+'')[0].offsetTop - 44
		        	}, 500);
		    },
		    // 计算项目所跨月份数
		    calcSumMonth(){
		      var startDateArr = this.projStartDate.split('-');
		      var endDateArr = this.projEndDate.split('-');

		      var startYear = Number(startDateArr[0]);
		      var startMonth = Number(startDateArr[1]);
		      var endYear = Number(endDateArr[0]);
		      var endMonth = Number(endDateArr[1]);

		      // 总月数计算
		      this.sumMonth = (12-startMonth+1)+(endYear-startYear-1)*12+endMonth;
		    },
		    // 计算项目预算
		    calcProjBudgetData(){

		      // 初始化数据
		      this.budgetCostData=[];

		      if(this.projStartDate === undefined || this.projStartDate === ''
		        || this.projEndDate === undefined || this.projEndDate === ''){
		        return;
		      }

		      // 内部人员数量
		      this.inPersonCount = this.inPersonData.length;
		      // 外部人员数量
		      this.outPersonCount = this.outPersonData.length;

		      // 内部月份人工成本
		      var inMonthCost = new Array();
	      	  // 差旅补贴月份成本
	      	  var travSubsidyMonthCost = new Array();
		      this.inPersonData.map((v,j)=>{
		        for(var i=1;i<=this.sumMonth;i++){
		          if(inMonthCost[i-1] === undefined){
		            inMonthCost[i-1] = (!isNaN(parseInt(v['ym'+i]))?parseInt(v['ym'+i]):0)*(!isNaN(parseFloat(v.settPrice))?parseFloat(v.settPrice):0);
		          }else{
		            inMonthCost[i-1] = inMonthCost[i-1] + (!isNaN(parseInt(v['ym'+i]))?parseInt(v['ym'+i]):0)*(!isNaN(parseFloat(v.settPrice))?parseFloat(v.settPrice):0);
		          }

		          // 每个月份的差旅补贴统计
	          	  if(travSubsidyMonthCost[i-1] === undefined){
	            	travSubsidyMonthCost[i-1] = (!isNaN(parseInt(v['ym'+i]))?parseInt(v['ym'+i]):0) * (!isNaN(parseInt(v.subsidy))?parseInt(v.subsidy):0);
	          	  }else{
	            	travSubsidyMonthCost[i-1] = travSubsidyMonthCost[i-1] + (!isNaN(parseInt(v['ym'+i]))?parseInt(v['ym'+i]):0) * (!isNaN(parseInt(v.subsidy))?parseInt(v.subsidy):0);
	          	  }
		        }
		      });

		      // 外部月份人工成本
		      var outMonthCost = new Array();
		      this.outPersonData.map((v,j)=>{
		        for(var i=1;i<=this.sumMonth;i++){
		          if(outMonthCost[i-1] === undefined){
		            outMonthCost[i-1] = (!isNaN(parseInt(v['ym'+i]))?parseInt(v['ym'+i]):0)*(!isNaN(parseFloat(v.settPrice))?parseFloat(v.settPrice):0);
		          }else{
		            outMonthCost[i-1] = outMonthCost[i-1] + (!isNaN(parseInt(v['ym'+i]))?parseInt(v['ym'+i]):0)*(!isNaN(parseFloat(v.settPrice))?parseFloat(v.settPrice):0);
		          }
		        }
		      });

		      // ***********************************预算数据的处理*****************************************

		      var startDateArr = this.projStartDate.split('-');
		      var endDateArr = this.projEndDate.split('-');

		      var startYear = Number(startDateArr[0]);
		      var startMonth = Number(startDateArr[1]);
		      var endYear = Number(endDateArr[0]);
		      var endMonth = Number(endDateArr[1]);

		      // 差旅补贴金额
		      var travSubsidyAmt = 0;
		      var travSubsidyItem = this.costData.find(item =>{
		      	return item.costTypeCode === '001';
		      });
		      if(travSubsidyItem !== undefined){
		      	travSubsidyAmt = parseFloat(travSubsidyItem.cost);
		      }

		      // 每月的其他费用，取整，最后一个月另算
		      //△//var monthOtherCost = parseInt(parseFloat(this.otherCost)/this.sumMonth);
		      var partOtherCost = parseFloat((this.otherCost - travSubsidyAmt).toFixed(2));
			  var monthOtherCost = parseFloat((partOtherCost/this.sumMonth).toFixed(2));
		      // 最后一个月 其他费用
		      var lastMonthOtherCost = parseFloat((partOtherCost - monthOtherCost*(this.sumMonth-1)).toFixed(2));
		      // 月列头处理
		      var index = 0;

		      // 直接成本中需要按月平分的处理
		      // 差旅交通
		      var travTraffic = 0;
		      // 驻地交通
		      var resiTraffic = 0;
		      // 住宿杂项
		      var stayExtras = 0;
		      // 其他费用
		      var otherItem = 0;
		      this.costData.map((v,i)=>{
		        if(v.costTypeCode === '002'){
		          // 差旅交通费
		          travTraffic = v.cost;
		        }
		        if(v.costTypeCode === '003'){
		          // 驻地交通费
		          resiTraffic = v.cost;
		        }
		        if(v.costTypeCode === '004'){
		          // 住宿杂项费
		          stayExtras = v.cost;
		        }
		        if(v.costTypeCode === '005'){
		          // 其他费用
		          otherItem = v.cost;
		        }
		      });
		      // 平均每月
		      var travTrafficMonth = parseFloat((parseFloat(travTraffic)/this.sumMonth).toFixed(2));
		      // 最后一个月
		      var lastTravTrafficMonth = parseFloat((travTraffic - travTrafficMonth*(this.sumMonth-1)).toFixed(2));

		      var resiTrafficMonth = parseFloat((parseFloat(resiTraffic)/this.sumMonth).toFixed(2));
		      var lastResiTrafficMonth = parseFloat((resiTraffic - resiTrafficMonth*(this.sumMonth-1)).toFixed(2));

		      var stayExtrasMonth = parseFloat((parseFloat(stayExtras)/this.sumMonth).toFixed(2));
		      var lastStayExtrasMonth = parseFloat((stayExtras - stayExtrasMonth*(this.sumMonth-1)).toFixed(2));

		      var otherItemMonth = parseFloat((parseFloat(otherItem)/this.sumMonth).toFixed(2));
		      var lastOtherItemMonth = parseFloat((otherItem - otherItemMonth*(this.sumMonth-1)).toFixed(2));

		      if(startYear != endYear){

		        for(var i=startMonth;i<=12;i++){
		          index++;
		          var inCost = parseFloat(inMonthCost[index-1]==undefined?0:inMonthCost[index-1].toFixed(2));
		          var outCost = parseFloat(outMonthCost[index-1]==undefined?0:outMonthCost[index-1].toFixed(2));
				  var travCost = parseFloat(travSubsidyMonthCost[index-1]==undefined?0:travSubsidyMonthCost[index-1].toFixed(2));
		          var item = {year:startYear,month:i,
					totalCost: parseFloat((inCost+outCost+travTrafficMonth+resiTrafficMonth+stayExtrasMonth+otherItemMonth+travCost).toFixed(2)),
		            inPersonCost:inCost,outPersonCost:outCost, 
    				travSubsidyCost:travCost,travTrafficCost:travTrafficMonth,resiTrafficCost:resiTrafficMonth,
    				stayExtrasCost:stayExtrasMonth,otherItemCost:otherItemMonth};
		          this.budgetCostData.push(item);

		          this.yearArr.push(startYear);
		          this.monthArr.push(i);
		        }

		        for(var i=startYear+1;i<endYear;i++){
		          for(var j=1;j<=12;j++){
		            index++;
		            var inCost = parseFloat(inMonthCost[index-1]==undefined?0:inMonthCost[index-1].toFixed(2));
		            var outCost = parseFloat(outMonthCost[index-1]==undefined?0:outMonthCost[index-1].toFixed(2));
				    var travCost = parseFloat(travSubsidyMonthCost[index-1]==undefined?0:travSubsidyMonthCost[index-1].toFixed(2));
		            var item = {year:i,month:j,
		            	totalCost:parseFloat((inCost+outCost+travTrafficMonth+resiTrafficMonth+stayExtrasMonth+otherItemMonth+travCost).toFixed(2)),
			            inPersonCost:inCost,outPersonCost:outCost, 
	    				travSubsidyCost:travCost,travTrafficCost:travTrafficMonth,resiTrafficCost:resiTrafficMonth,
	    				stayExtrasCost:stayExtrasMonth,otherItemCost:otherItemMonth};
			            this.budgetCostData.push(item);

				        this.yearArr.push(i);
				        this.monthArr.push(j);
		          }
		        }

		        for(var i=1;i<=endMonth;i++){
		          index++;
		          var inCost = parseFloat(inMonthCost[index-1]==undefined?0:inMonthCost[index-1].toFixed(2));
		          var outCost = parseFloat(outMonthCost[index-1]==undefined?0:outMonthCost[index-1].toFixed(2));
				  var travCost = parseFloat(travSubsidyMonthCost[index-1]==undefined?0:travSubsidyMonthCost[index-1].toFixed(2));
		          var item = {year:endYear,month:i,
		            totalCost:parseFloat((inCost+outCost+travTrafficMonth+resiTrafficMonth+stayExtrasMonth+otherItemMonth+travCost).toFixed(2)),
		            inPersonCost:inCost,outPersonCost:outCost, 
    				travSubsidyCost:travCost,travTrafficCost:travTrafficMonth,resiTrafficCost:resiTrafficMonth,
    				stayExtrasCost:stayExtrasMonth,otherItemCost:otherItemMonth};
		          this.budgetCostData.push(item);

			      this.yearArr.push(endYear);
			      this.monthArr.push(i);
		        }
		      }else{
		        
		        for(var i=startMonth;i<=endMonth;i++){
		          index++;
		          var inCost = parseFloat(inMonthCost[index-1]==undefined?0:inMonthCost[index-1].toFixed(2));
		          var outCost = parseFloat(outMonthCost[index-1]==undefined?0:outMonthCost[index-1].toFixed(2));
				  var travCost = parseFloat(travSubsidyMonthCost[index-1]==undefined?0:travSubsidyMonthCost[index-1].toFixed(2));
		          var item = {year:startYear,month:i,
		          	totalCost:parseFloat((inCost+outCost+travTrafficMonth+resiTrafficMonth+stayExtrasMonth+otherItemMonth+travCost).toFixed(2)),
		            inPersonCost:inCost,outPersonCost:outCost, 
    				travSubsidyCost:travCost,travTrafficCost:travTrafficMonth,resiTrafficCost:resiTrafficMonth,
    				stayExtrasCost:stayExtrasMonth,otherItemCost:otherItemMonth};
		          this.budgetCostData.push(item);

			      this.yearArr.push(startYear);
			      this.monthArr.push(i);
		        }
		      }

		      // 最后一个月的 其他费用、总费用 赋值
      		  var travLastCost = parseFloat(travSubsidyMonthCost[this.sumMonth-1]==undefined?0:travSubsidyMonthCost[this.sumMonth-1].toFixed(2));
      		  this.budgetCostData[this.sumMonth-1].travTrafficCost = lastTravTrafficMonth;
		      this.budgetCostData[this.sumMonth-1].resiTrafficCost = lastResiTrafficMonth;
		      this.budgetCostData[this.sumMonth-1].stayExtrasCost = lastStayExtrasMonth;
		      this.budgetCostData[this.sumMonth-1].otherItemCost = lastOtherItemMonth;
		      this.budgetCostData[this.sumMonth-1].totalCost = parseFloat((this.budgetCostData[this.sumMonth-1].inPersonCost 
		        +this.budgetCostData[this.sumMonth-1].outPersonCost+ travLastCost+lastTravTrafficMonth+lastResiTrafficMonth
        		+lastStayExtrasMonth+lastOtherItemMonth).toFixed(2));


		      // 毛利率计算
		      if(this.sumContAmt === null || this.sumContAmt === undefined || this.sumContAmt ===''){
		      	this.gm = '-';
		      }else{
		      	this.gm = (((this.sumContAmt-this.totalCost)/this.sumContAmt)*100).toFixed(2)+'%';
		      }
		    },
		    // 人员计划详细点击事件
		    personItemClick(item,type){
		    	this.personPlanType = type;
		    	this.personPlanInfo = item;

		    	// 获取月度数据
		    	this.personMonthData=[];
		    	for(var i=0;i<this.sumMonth;i++){
		    		var itemInfo = {year:this.yearArr[i],month:this.monthArr[i],workDays:item["ym"+(i+1)]};
		    		this.personMonthData.push(itemInfo);
		    	}

		    	this.openFullscreen = true;
		    },
		    // 人天预算种类 人员计划详细事件
		    personServiceItemClick(item,type){
		    	this.personPlanType = type;
		    	this.personPlanInfo = item;
		    	this.openServiceFullscreen = true;
		    },
		    // 月度计划成本明细
		    budgetItemClick(id){

		    },
		    // 直接成本明细
		    costItemClick(id){

		    },
    	}
	}



// WEBPACK FOOTER //
// ./src/view/pm/budget/budgetDetail.vue